import { createContext, useContext } from "react";

export const StatesSlotContext = createContext(null);

export const useStatesSlot = () => useContext(StatesSlotContext);

export const FieldsSlotContext = createContext(null);

export const useFieldsSlot = () => useContext(FieldsSlotContext);
